import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
  ChangeDetectorRef,
} from '@angular/core';
import { Client, TENANTSINTERFACE } from '@fitness-force/models';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { PopoverModule } from 'primeng/popover';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { AssignKeyFobComponent } from '../../../../../shared/src/lib/components/client-profile/assign-key-fob/assign-key-fob.component';
import { BlockClientComponent } from '../../../../../shared/src/lib/components/client-profile/block-client/block-client.component';
import { ChangePasswordComponent } from '../../../../../shared/src/lib/components/client-profile/change-password/change-password.component';
import { ChangeSalesRepresentativeComponent } from '../../../../../shared/src/lib/components/client-profile/change-sales-representative/change-sales-representative.component';
import { CreateOpportunityComponent} from '@fitness-force/crm'
import { TaskCreateComponent } from '../../../../../shared/src/lib/components/task/task-create/task-create.component';
import { Store } from '@ngrx/store';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FolderCreateDialogComponent } from '../../../../../shared/src/lib/components/create-folder-dialog/folder-create-dialog.component';
import { AddAttachmentDialogComponent } from '../../../../../shared/src/lib/components/add-attachment-dialog/add-attachment-dialog.component';
import { AttachmentsComponent } from '../../../../../shared/src/lib/components/client-profile/attachments/attachments.component';
import { ProspectFormComponent } from 'libs/core/src/lib/prospect-form/prospect-form.component';
import { TransferProspectComponent } from 'libs/shared/src/lib/components/client-profile/transfer-prospect/transfer-prospect.component';
import { DeleteDigitalPassComponent } from '../../../../../shared/src/lib/components/client-profile/delete-digital-pass/delete-digital-pass.component';

@Component({
  selector: 'prospect-list-actions',
  templateUrl: './prospect-list-actions.component.html',
  styleUrls: ['./prospect-list-actions.component.scss'],
  providers: [DialogService  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule,
    ButtonModule,
    RippleModule,
    StyleClassModule,
    PopoverModule,
    SelectModule,
    DialogModule,
    AvatarModule,
    TableModule,
    InputTextModule,
    CreateOpportunityComponent,
    TaskCreateComponent,
    ChangePasswordComponent,
    BlockClientComponent,
    AssignKeyFobComponent,
    AttachmentsComponent,
    ChangeSalesRepresentativeComponent,
    RouterModule,
    ProspectFormComponent,
    TransferProspectComponent,
    DeleteDigitalPassComponent,
    TranslateModule]
})
export class ProspectListActionsComponent implements OnInit {
  @Input() columnData = new BehaviorSubject<any>(null);
  @Input() isAllSelected = new BehaviorSubject(false);
  @Output() onAction = new EventEmitter(); // {type:actionName,columnData }
  @Input() selectedRows = new BehaviorSubject(new Map());
  @Input() rowIndex = 0;
  @Input() tableAction:boolean = true;
  @Input() showDeleteDigitalPass: boolean = false;
  @Output() changeEvent = new EventEmitter();

  showOppDialog = false;
  showTaskCreate = false;
  clients = new BehaviorSubject<Array<any>>([]);
  clientDetails: any = [];
  clientIds: number[] = [];
  showCreateProspectPopup: Observable<boolean> = of(false);
  showCreateOpportunityPopup: Observable<boolean> | any = false;
  toggleEditProfileDialog$ = new BehaviorSubject<boolean | null>(false);
  toggleChangePasswordDialog$ = new BehaviorSubject<boolean | null>(false);
  toggleBlockClientDialog$ = new BehaviorSubject<boolean | null>(false);
  toggleAssignKeyFobDialog$ = new BehaviorSubject<boolean | null>(false);
  toggleChangeSaleRepDialog$ = new BehaviorSubject<boolean | null>(false);
  toggleTransferProspectDialog$ = new BehaviorSubject<boolean | null>(false);
  toggleDeleteDigitalKeyFobDialog$ = new BehaviorSubject<boolean | null>(false);
  selectedClient: any = new Map();
  deleteProfileModal= false;
  mergeProfileModal= false;
  cancelInvoiceModal= false;
  changeBillOwnerModal= false;
  enquirySourceDisable= true;
  hideDropdown= true;
  confirmDeleteProfileModal = false;
  attachmentsModal=false;
  tableData: any;
  allClientData = new BehaviorSubject(null);
  isObservable = false;

  // coldata
  colData!: any;

  tenantId = 0;
  getAccessTenantList$: Observable<any> | any;
  errMsg: Error | any;
  refDialog?: DynamicDialogRef;
  constructor(
    private translate: TranslateService,
    private store: Store,
    private router: Router,
    private dialogService: DialogService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.clientIds = [];
    this.columnData.subscribe((val: any) => {
      this.colData = val;
      this.selectedClient.set('id', val);
      this.clients.next(this.getSelectedClientData);
      this.clientDetails = this.getSelectedClientData;

    });
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
    });
  }

  newOpportunity() {
    this.showOppDialog = true;
    return this.showOppDialog;
  }

  HideTaskCreate(e: any) {
    this.showTaskCreate = false;
    this.cd.detectChanges();

  }

  hidePopup(isHide: boolean) {
    this.showCreateProspectPopup = of(isHide);
  }

  get getSelectedClientData(): Array<Client> {
    return [...this.selectedClient.values()];
  }

  showOpp() {
    this.showCreateOpportunityPopup = true;
  }

  OpenPopup() {
    this.showCreateProspectPopup = of(true);
  }

  hideOpportunity(isHide: any) {
    this.showCreateOpportunityPopup = false;
    this.changeEvent.emit({ action: "updated" });
  }

  newTask(data: any) {
    if (this.clientIds.length > 0) {
      this.clientIds = [];
    }
    this.clientIds.push(data.id);

    this.showTaskCreate = true;
  }

  toggleEditProfileDialog() {
    console.log(this.colData);
    this.toggleEditProfileDialog$.next(true);
  }

  closeEditProfile(e: any) {
    this.toggleEditProfileDialog$.next(false);
    this.changeEvent.emit(e);
  }
  
  closeAssignKeyFob(e: boolean) {
    this.toggleAssignKeyFobDialog$.next(false);
    this.changeEvent.emit(e);
    this.onAction.emit({action:'updated',columnData: this.colData})
  }

  toggleChangePasswordDialog() {
    this.toggleChangePasswordDialog$.next(true);
  }

  closeChangePasswordDialog(e: any) {
    this.toggleChangePasswordDialog$.next(false);
    this.changeEvent.emit(true);
  }

  toggleBlockClientDialog() {
    this.toggleBlockClientDialog$.next(true);
  }

  toggleAssignKeyFobDialog() {
    this.toggleAssignKeyFobDialog$.next(true);
  }

  closeBlockClientDialog(e: any) {
    if (e.close) this.toggleBlockClientDialog$.next(false);
    this.changeEvent.emit(e);
  }

  closeDeleteDigitalPassDialog(e: any) {
    if (e.close) this.toggleDeleteDigitalKeyFobDialog$.next(false);
    this.changeEvent.emit(e);
  }

  toggleChangeSaleRepDialog() {
    this.toggleChangeSaleRepDialog$.next(true);
  }

  closeChangeSaleRepDialog(e: boolean) {
    this.toggleChangeSaleRepDialog$.next(false);
    this.changeEvent.emit(e);
  }

  toggleDeleteDigitalKeyFobDialog() {
    this.toggleDeleteDigitalKeyFobDialog$.next(true);
  }

  navigateToBillinging(clientData: any) {
    this.router.navigate(['/pos/pos-addon-charges', clientData.id]);
  }

  toggleTransferProspectDialog(event: any) {
    this.toggleTransferProspectDialog$.next(true);
    //this.changeEvent.emit(event);
  }

  closeTransferProspectDialog(e: boolean) {
    this.toggleTransferProspectDialog$.next(false);
    this.changeEvent.emit(e);
  }

  addFolder(activeFolder: any = null) {
    this.refDialog = this.dialogService.open(FolderCreateDialogComponent, {
      showHeader: false,
      baseZIndex: 10000,
      contentStyle: { 'max-height': '500px', 'min-width': '400px', 'max-width': '600px' },
      data: { activeFolder },
    });
    this.refDialog.onClose.subscribe((folder: any) => {
      if (folder) {
       // this.getChargeList();
      }
    });
  }

  uploadAttachment() {
    this.refDialog = this.dialogService.open(AddAttachmentDialogComponent, {
      showHeader: false,
      baseZIndex: 10000,
      contentStyle: {  'min-width': '400px', 'max-width': '800px' },
      data: { clientId:this.selectedClient.get('id')?.id },
    });
    this.refDialog.onClose.subscribe((folder: any) => {
      if (folder) {
       // this.getChargeList();
      }
    });
  }

  closeAttachmentDialog(event:any){
    if(event)
    this.attachmentsModal=false;
  }


}